(() => {
  const source = 'https://js.squarecdn.com/square-marketplace.js';
  let loadPromise;

  const load = () => {
    if (window.customElements?.get('square-placement')) return Promise.resolve();
    if (loadPromise) return loadPromise;

    loadPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${source}"]`);
      if (existing) {
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = source;
      script.async = true;
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    return loadPromise;
  };

  const loadAfterPrimaryWork = () => {
    load().catch(() => {});
  };

  // A colour or size selection can start a product-section request. Loading the
  // third-party SDK from that same pointer event makes both jobs compete. Scroll
  // is a safer intent signal because the critical product interaction has
  // already had a chance to settle.
  window.addEventListener('scroll', loadAfterPrimaryWork, { once: true, passive: true });

  window.addEventListener('load', () => {
    window.setTimeout(loadAfterPrimaryWork, 20000);
  }, { once: true });

  window.tlcLoadAfterpay = load;
})();
